
export const showUserEventsSelector = state => state.eventChart.showUserEvents;

export const showAlarmEventsSelector = state => state.eventChart.showAlarmEvents;

export const showConnectivityEventsSelector = state => state.eventChart.showConnectivityEvents;

export const showChipStateEventsSelector = state => state.eventChart.showChipStateEvents;